'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/rykPDP'));
    processInclude(require('./product/lensRecipeHelper'));
    processInclude(require('./product/consultarReceta'));
    processInclude(require('./product/repeatOrder'));
    processInclude(require('./product/repeatOrderSubscription'));
    processInclude(require('./product/detail'));
    processInclude(require('./product/subscription'));
    processInclude(require('./product/consultarRecetaSubscription'));
    processInclude(require('./product/sptInsurance'));
    processInclude(require('./product/badges'));
    processInclude(require('./product/benefitBadges'));
    // Wishlist
    processInclude(require('./product/wishlist'));
    processInclude(require('./product/bankAffiliation'));
    processInclude(require('./product/secondUnitPromotion'));
});
